import { render } from "./LandingPageDepoimentoCard.vue?vue&type=template&id=3966b7bd&scoped=true"
import script from "./LandingPageDepoimentoCard.vue?vue&type=script&lang=js"
export * from "./LandingPageDepoimentoCard.vue?vue&type=script&lang=js"

import "./LandingPageDepoimentoCard.vue?vue&type=style&index=0&id=3966b7bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3966b7bd"]])

export default __exports__